import { j as t } from "../../_virtual/jsx-runtime.js";
import * as l from "react";
import { Overlay as d, Portal as f, Content as r, Title as n, Description as m, Root as p, Close as g, Trigger as x } from "../../node_modules/@radix-ui/react-dialog/dist/index.js";
import { cn as s } from "../../lib/utils.js";
import { VisuallyHidden as u } from "../../node_modules/@radix-ui/react-visually-hidden/dist/index.js";
const z = p, C = x, N = f, k = g, c = l.forwardRef(({ className: a, ...e }, o) => /* @__PURE__ */ t.jsx(
  d,
  {
    ref: o,
    className: s(
      "fixed grid place-items-center overflow-auto inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      a
    ),
    ...e
  }
));
c.displayName = d.displayName;
const y = l.forwardRef(({ className: a, children: e, ...o }, i) => /* @__PURE__ */ t.jsx(N, { children: /* @__PURE__ */ t.jsx(c, { children: /* @__PURE__ */ t.jsx(
  r,
  {
    ref: i,
    className: s(
      "z-50 grid w-full max-w-lg gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
      a
    ),
    ...o,
    children: e
  }
) }) }));
y.displayName = r.displayName;
const D = ({
  className: a,
  ...e
}) => /* @__PURE__ */ t.jsx(
  "div",
  {
    className: s(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      a
    ),
    ...e
  }
);
D.displayName = "DialogHeader";
const j = ({
  className: a,
  ...e
}) => /* @__PURE__ */ t.jsx(
  "div",
  {
    className: s(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      a
    ),
    ...e
  }
);
j.displayName = "DialogFooter";
const w = l.forwardRef(({ className: a, title: e, ...o }, i) => /* @__PURE__ */ t.jsx(
  n,
  {
    ref: i,
    className: s(
      "text-lg font-semibold leading-none tracking-tight",
      a
    ),
    ...o,
    children: e || /* @__PURE__ */ t.jsx(u, { children: "Dialog Title" })
  }
));
w.displayName = n.displayName;
const R = l.forwardRef(({ className: a, ...e }, o) => /* @__PURE__ */ t.jsx(
  m,
  {
    ref: o,
    className: s("text-sm text-muted-foreground", a),
    ...e
  }
));
R.displayName = m.displayName;
export {
  z as Dialog,
  k as DialogClose,
  y as DialogContent,
  R as DialogDescription,
  j as DialogFooter,
  D as DialogHeader,
  c as DialogOverlay,
  N as DialogPortal,
  w as DialogTitle,
  C as DialogTrigger
};
